export const ACCEPT_EXTENSIONS = '.png,.jpeg,.jpg,.webp,.gif,.pdf,.csv,.txt'

const ACCEPTED_EXTENSIONS_LIST = ACCEPT_EXTENSIONS.split(',').map(ext => ext.toLowerCase().trim())

const ACCEPTED_EXTENSION_BY_MIME_TYPE: Record<string, string> = {
  'image/png': '.png',
  'image/jpeg': '.jpg',
  'image/webp': '.webp',
  'image/gif': '.gif',
  'application/pdf': '.pdf',
  'text/csv': '.csv',
  'text/plain': '.txt',
}

const getFileExtension = (fileName: string): string => {
  const lastDotIndex = fileName.lastIndexOf('.')
  return lastDotIndex >= 0 ? fileName.toLowerCase().substring(lastDotIndex) : ''
}

export const isValidChatFileExtension = (fileName: string): boolean =>
  ACCEPTED_EXTENSIONS_LIST.includes(getFileExtension(fileName))

export function normalisePastedChatFile(file: File, index: number): File {
  if (getFileExtension(file.name)) {
    return file
  }

  const extension = ACCEPTED_EXTENSION_BY_MIME_TYPE[file.type.toLowerCase()]
  if (!extension) {
    return file
  }

  const fallbackName = `pasted-file-${index + 1}`
  const fileName = file.name ? `${file.name}${extension}` : `${fallbackName}${extension}`

  return new File([file], fileName, {
    type: file.type,
    lastModified: file.lastModified,
  })
}

export function getClipboardChatFiles(clipboardData: DataTransfer): Array<File> {
  const itemFiles = Array.from(clipboardData.items)
    .filter(item => item.kind === 'file')
    .map(item => item.getAsFile())
    .filter((file): file is File => Boolean(file))

  const dedupedFiles = [...itemFiles, ...Array.from(clipboardData.files)].filter((file, index, allFiles) => {
    const fileKey = getChatFileKey(file)
    return allFiles.findIndex(candidate => getChatFileKey(candidate) === fileKey) === index
  })

  return dedupedFiles.map(normalisePastedChatFile)
}

export function partitionChatFiles(files: Array<File>): { validFiles: Array<File>; invalidFileNames: Array<string> } {
  const validFiles: Array<File> = []
  const invalidFileNames: Array<string> = []

  files.forEach((file, index) => {
    if (isValidChatFileExtension(file.name)) {
      validFiles.push(file)
    } else {
      invalidFileNames.push(file.name || `pasted-file-${index + 1}`)
    }
  })

  return { validFiles, invalidFileNames }
}

function getChatFileKey(file: File): string {
  return [
    file.name,
    file.size,
    file.type,
    file.lastModified,
  ].join(':')
}
